import { Navigate, useLocation } from "react-router-dom";
import { useWorkspaces } from "../../identity";
import { pickDefaultWorkspace } from "../../workspaces";
import { BootScreen, LoadingDots } from "../../components/layout/DashboardBoot";

/* Workspace-less entry to the welcome wizard. The URL (/welcome) carries no
 * workspace, so it's a clean shareable link; it resolves the viewer's last-used
 * (else default) workspace and redirects to that workspace's /w/:id/welcome —
 * the real full-screen wizard, which needs workspace-scoped data providers
 * (agents, traffic) that only exist under WorkspaceShell. */
export default function PublicWelcomePage() {
  const { data: workspaces, error, initialLoading } = useWorkspaces();
  const { search } = useLocation();

  if (error) {
    return (
      <BootScreen>
        <p className="text-body-sm text-error-fg">
          Couldn’t load your workspaces. Check your connection and reload.
        </p>
      </BootScreen>
    );
  }

  if (initialLoading || !workspaces) {
    return (
      <BootScreen>
        <LoadingDots />
      </BootScreen>
    );
  }

  const target = pickDefaultWorkspace(workspaces);
  if (!target) {
    return (
      <BootScreen>
        <div className="flex max-w-sm flex-col items-center gap-2 text-center">
          <p className="text-body font-medium text-fg-1">No workspaces yet</p>
          <p className="text-body-sm text-fg-2">
            Your account has no workspaces. Ask your organization admin for
            access, then reload.
          </p>
        </div>
      </BootScreen>
    );
  }

  return (
    <Navigate
      to={`/w/${encodeURIComponent(target.id)}/welcome${search}`}
      replace
    />
  );
}
